import React from 'react';

const farmImages = [
	{
		id: 1,
		image: 'https://res.cloudinary.com/dgtbjxhqs/image/upload/v1750766477/Dari_Farms_3_gdnfdp.jpg',
	},
	{
		id: 2,
		image: 'https://res.cloudinary.com/dgtbjxhqs/image/upload/v1750766480/Dari_Farms_8_n5s32m.jpg',
	},
	{
		id: 3,
		image: 'https://res.cloudinary.com/dgtbjxhqs/image/upload/v1750766475/Dari_Farms_14_k8g99o.jpg',
	},
	{
		id: 4,
		image: 'https://res.cloudinary.com/dgtbjxhqs/image/upload/v1750766476/Dari_Farms_2_rth9hd.jpg',
	},
	{
		id: 5,
		image: 'https://res.cloudinary.com/dgtbjxhqs/image/upload/v1750766473/Dari_Farms_1_tdpfm0.jpg',
	},
	{
		id: 6,
		image: 'https://res.cloudinary.com/dgtbjxhqs/image/upload/v1750766474/Dari_Farms_10_gpo6dq.jpg',
	},
	{
		id: 7,
		image: 'https://res.cloudinary.com/dgtbjxhqs/image/upload/v1750766474/Dari_Farms_13_gqc02p.jpg',
	},
];

export default function Farms() {
	return (
		<div className="container mx-auto px-4 py-16 mt-8">
			<h2 className="text-4xl font-bold text-left mb-12 mt-12">
				Dari Farms Gallery
			</h2>

			<div className="grid grid-cols-1 md:grid-cols-3 gap-4">
				{farmImages.map((item) => (
					<div
						key={item.id}
						className="relative group overflow-hidden rounded-xl shadow-lg"
						style={{ height: '400px' }}
					>
						<div
							className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-110"
							style={{ backgroundImage: `url(${item.image})` }}
						/>
						<div className="absolute inset-0 bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
					</div>
				))}
			</div>
		</div>
	);
}